<template>
  <div>
    <!-- 创建模板 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="templateVisible"
      center
      width="70%">
      <div>
        <el-form size="small" label-width="140px">
          <el-form-item label="模板类型">
            <el-select v-model="reqTemplate.type" :disabled="!typeOptionEdit" placeholder="请选择" style="width: 60%;">
              <el-option
                v-for="item in typeOption"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="模板名称">
            <el-input :disabled="isChildTemplate" v-model="reqTemplate.templateName" placeholder="请输入模板名称" style="width: 60%;"/>
          </el-form-item>
          <el-form-item label="标签" v-show="reqTemplate.type === 'svoice'">
            <el-select v-model="reqTemplate.labels" clearable filterable placeholder="请选择" multiple collapse-tags style="width: 60%;">
              <el-option v-for="item in labelList" :key="item.id" :label="item.name" :value="item.name" :title="item.name"/>
            </el-select>
          </el-form-item>
          <el-form-item label="录音员" v-show="reqTemplate.type === 'svoice'">
            <el-select v-model="reqTemplate.recorderId" placeholder="请选择录音员"  style="width: 60%;" filterable>
              <el-option
                v-for="item in recorderOption"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="特殊逻辑" v-show="reqTemplate.type === 'svoice'">
            <el-select v-model="reqTemplate.logicType" placeholder="请选择逻辑类型"  style="width: 60%;" filterable>
              <el-option
                v-for="item in templateLogicOption"
                :key="item.code"
                :label="item.name"
                :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="触发条件" v-show="reqTemplate.type === 'svoice' && reqTemplate.logicType===2">
            <el-select v-model="reqTemplate.triggerConditions" placeholder="请选择逻辑类型" style="width: 60%;" filterable multiple>
              <el-option v-for="item in triggerConditionOption" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>

          <div v-show="isChildTemplate">
            <el-form-item label="优先级">
              <el-input-number
                v-model="reqTemplate.sort"
                style="width:20%"
                placeholder="请输入0-100"
                :disabled="!priorityEditable"
                :min="0"
                :max="100">
              </el-input-number>
            </el-form-item>
            <el-form-item label="模板开关">
              <el-switch
                v-model="reqTemplate.templateStatus">
              </el-switch>
            </el-form-item>
            <el-form-item label="条件">
              <el-button size="mini" type="text" v-if="!condition.conditionShow" @click="deploy(true)">展开<el-icon class="el-icon-arrow-down"></el-icon></el-button>
              <el-button size="mini" type="text" v-if="condition.conditionShow" @click="deploy(false)">收缩<el-icon class="el-icon-arrow-up"></el-icon></el-button>
            </el-form-item>
            <div v-show="condition.conditionShow" style="margin-bottom:25px;">
              <el-row :gutter="24">
                <el-col :span="12">
                  <el-col :span="8">
                    <el-button :class="condition.sex.class" type="text" @click="conditionClick(conditionType.sex, condition.sex.settingShow)">性别</el-button>
                  </el-col>
                  <el-col :span="8">
                    <el-select v-if="condition.sex.settingShow" v-model="condition.sex.sexMath" style="width:100%">
                      <el-option
                        v-for="item in sexMathOption"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8">
                    <el-select v-if="condition.sex.settingShow" v-model="condition.sex.sexSelect" style="width:100%">
                      <el-option
                        v-for="item in sexSelectOption"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                </el-col>
                <el-col :span="12">
                  <el-col :span="8">
                    <el-button :class="condition.executeRecord.class" type="text" @click="conditionClick(conditionType.executeRecord, condition.executeRecord.settingShow)">法院执行记录</el-button>
                  </el-col>
                  <el-col :span="8">
                    <el-select v-if="condition.executeRecord.settingShow" v-model="condition.executeRecord.executeRecordMath" style="width:100%">
                      <el-option
                        v-for="item in executeRecordMathOption"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8">
                    <el-select v-if="condition.executeRecord.settingShow" v-model="condition.executeRecord.executeRecordSelect" style="width:100%">
                      <el-option
                        v-for="item in executeRecordSelectOption"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                </el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :span="12">
                  <el-col :span="8">
                    <el-button :class="condition.age.class" type="text" @click="conditionClick(conditionType.age, condition.age.settingShow)">年龄</el-button>
                  </el-col>
                  <el-col :span="8">
                    <el-select v-if="condition.age.settingShow" v-model="condition.age.ageMath" style="width:100%">
                      <el-option
                        v-for="item in ageMathOption"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8">
                    <el-input-number
                      v-if="condition.age.settingShow"
                      v-model="condition.age.ageInput"
                      style="width:100%"
                      placeholder="请输入0-100"
                      :min="0"
                      :max="100">
                    </el-input-number>
                  </el-col>
                </el-col>
                <el-col :span="12">
                  <el-col :span="8">
                    <el-button :class="condition.keyWord.class" type="text" @click="conditionClick(conditionType.keyWord, condition.keyWord.settingShow)">关键词</el-button>
                  </el-col>
                  <el-col :span="8">
                    <el-select v-if="condition.keyWord.settingShow" v-model="condition.keyWord.keyWordMath" style="width:100%">
                      <el-option
                        v-for="item in keyWordMathOption"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8">
                    <el-input
                      v-if="condition.keyWord.settingShow"
                      v-model="condition.keyWord.keyWordTextarea"
                      type="textarea"
                      rows="1"
                      placeholder="使用英文逗号隔开"
                      maxlength="100"
                      clear
                      style="width:100%">
                    </el-input>
                  </el-col>
                </el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :span="12">
                  <el-col :span="8">
                    <el-button :class="condition.repayCount.class" type="text" @click="conditionClick(conditionType.repayCount, condition.repayCount.settingShow)">逾期次数</el-button>
                  </el-col>
                  <el-col :span="8">
                    <el-select v-if="condition.repayCount.settingShow" v-model="condition.repayCount.repayCountMath" style="width:100%">
                      <el-option
                        v-for="item in ageMathOption"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8">
                    <el-input-number
                      v-if="condition.repayCount.settingShow"
                      v-model="condition.repayCount.repayCountInput"
                      style="width:100%"
                      placeholder="请输入0-100"
                      :min="0"
                      :max="100">
                    </el-input-number>
                  </el-col>
                </el-col>
                <el-col :span="12">
                  <el-col :span="8">
                    <el-button :class="condition.casePlanDiscount.class" type="text" @click="conditionClick(conditionType.casePlanDiscount, condition.casePlanDiscount.settingShow)">是否减免</el-button>
                  </el-col>
                  <el-col :span="8">
                    <el-select v-if="condition.casePlanDiscount.settingShow" v-model="condition.casePlanDiscount.casePlanDiscountMath" style="width:100%">
                      <el-option
                        v-for="item in casePlanDiscountMathOption"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8">
                  </el-col>
                </el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :span="12">
                  <el-col :span="8">
                    <el-button :class="condition.promisePayTime.class" type="text" @click="conditionClick(conditionType.promisePayTime, condition.promisePayTime.settingShow)">承诺还款时间距离当前天数</el-button>
                  </el-col>
                  <el-col :span="8">
                    <el-select v-if="condition.promisePayTime.settingShow" v-model="condition.promisePayTime.promisePayTimeMath" style="width:100%" @change="promisePayTimeMathChange">
                      <el-option
                        v-for="item in promisePayTimeMathOption"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8">
                    <el-input-number
                      v-if="condition.promisePayTime.settingShow"
                      v-model="condition.promisePayTime.promisePayTimeInput"
                      style="width:100%"
                      placeholder="请输入0-100"
                      v-show="promisePayTimeInputVisible"
                      :min="0"
                      :max="100">
                    </el-input-number>
                  </el-col>
                </el-col>
                <el-col :span="12">
                  <el-col :span="8">
                    <el-button :class="condition.comboxCase.class" type="text" @click="conditionClick(conditionType.comboxCase, condition.comboxCase.settingShow)">是否合并案件</el-button>
                  </el-col>
                  <el-col :span="8">
                    <el-select v-if="condition.comboxCase.settingShow" v-model="condition.comboxCase.comboxCaseMath" style="width:100%">
                      <el-option
                        v-for="item in casePlanDiscountMathOption"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8">
                  </el-col>
                </el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :span="12">
                  <el-col :span="8">
                    <el-button :class="condition.overdueDate.class" type="text" @click="conditionClick(conditionType.overdueDate, condition.overdueDate.settingShow)">逾期天数</el-button>
                  </el-col>
                  <el-col :span="8">
                    <el-select v-if="condition.overdueDate.settingShow" v-model="condition.overdueDate.overdueDatesMath" style="width:100%">
                      <el-option
                        v-for="item in ageMathOption"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8">
                    <el-input-number
                      v-if="condition.overdueDate.settingShow"
                      v-model="condition.overdueDate.overdueDatesInput"
                      style="width:100%"
                      placeholder="请输入0-100"
                      :min="0"
                      :max="100">
                    </el-input-number>
                  </el-col>
                </el-col>
                <el-col :span="12">
                  <el-col :span="8">
                    <el-button :class="condition.productName.class" type="text" @click="conditionClick(conditionType.productName, condition.productName.settingShow)">产品名称</el-button>
                  </el-col>
                  <el-col :span="8">
                    <el-select v-if="condition.productName.settingShow" v-model="condition.productName.productNameMath" style="width:100%">
                      <el-option
                        v-for="item in productNameOption"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8">
                    <el-input
                      v-if="condition.productName.settingShow"
                      v-model="condition.productName.productNameTextarea"
                      type="textarea"
                      rows="1"
                      placeholder="请输入产品名称"
                      maxlength="100"
                      clear
                      style="width:100%">
                    </el-input>
                  </el-col>
                </el-col>
              </el-row>
            </div>
            <!-- 分支模板条件 -->
            <el-form-item label="分支模板条件">
              <div>
                <el-button type="text" size="small" @click="branchConditionShow = !branchConditionShow">
                  {{ branchConditionShow ? '收缩' : '展开' }}
                  <i :class="branchConditionShow ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
                </el-button>
                <div v-show="branchConditionShow">
                  <div v-for="(condition, index) in branchConditions" :key="condition.id" style="display: flex; align-items: center; gap: 12px; margin-bottom: 12px;">
                    <span style="white-space: nowrap;">条件</span>
                    <el-select v-model="condition.conditionType" placeholder="请选择" size="small" style="width: 140px;" @change="onBranchConditionChange(index)" filterable>
                      <el-option
                        v-for="item in branchConditionTypeOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                    <el-tooltip v-if="getSelectedConditionLabel(condition.conditionType) === '入案天数（0~30）'" effect="dark" placement="top">
                      <div slot="content">入案天数=当前日期-入案日期，如2026.6.18入案，当前日期为2026.6.19，入案天数为1</div>
                      <i class="el-icon-question" style="color: #909399; cursor: pointer;"></i>
                    </el-tooltip>
                    <span style="white-space: nowrap;">逻辑</span>
                    <el-select v-model="condition.logicType" placeholder="请选择" size="small" style="width: 140px;">
                      <el-option
                        v-for="item in condition.logicOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                    <span style="white-space: nowrap;">参数</span>
                    <template v-if="isBranchRangeLogic(condition.logicType)">
                      <el-input v-model="condition.minValue" size="small" style="width: 120px;" placeholder="最小值" />
                      <span>至</span>
                      <el-input v-model="condition.maxValue" size="small" style="width: 120px;" placeholder="最大值" />
                    </template>
                    <template v-else>
                      <el-input v-model="condition.minValue" size="small" style="width: 120px;" placeholder="参数值" />
                    </template>
                    <el-button type="danger" size="mini" icon="el-icon-delete" plain circle @click="removeBranchCondition(index)" />
                  </div>
                  <el-button type="primary" size="small" icon="el-icon-plus" @click="addBranchCondition">新增</el-button>
                </div>
              </div>
            </el-form-item>
          </div>
          <el-form-item :label="internationalVersionFlag == 1 ? '模版内容（原文）' : '模板内容'">
            <div style="display: flex; align-items: flex-start; gap: 10px;">
              <div id="manualSendMessageContent" v-html="reqTemplate.templateContent" @keyup="checkNum" rows="8" contentEditable="plaintext-only" @focus="activeEditableDiv = 'manualSendMessageContent'" :style="internationalVersionFlag == 1 ? 'width: 35%;height: 150px;border: 1px solid #dcdfe6;border-radius: 4px; overflow-y: auto;' : 'width: 60%;height: 150px;border: 1px solid #dcdfe6;border-radius: 4px; overflow-y: auto;'">
              </div>
              <el-button v-if="internationalVersionFlag == 1" type="primary" size="small" icon="el-icon-arrow-right" circle @click="translateToChinese" style="margin-top: 60px;"></el-button>
              <div v-if="internationalVersionFlag == 1" style="position: relative; width: 35%;">
                <div v-html="translatedToChinese" contentEditable="false" style="width: 100%;height: 150px;border: 1px solid #e4e7ed;border-radius: 4px; overflow-y: auto;background-color: #f5f7fa;cursor: default;">
                </div>
                <div style="position: absolute; right: 5px; bottom: 5px; display: flex; align-items: center; gap: 5px;">
                  <el-button type="text" size="mini" @click="autoFillToChinese">
                    自动填充
                  </el-button>
                  <el-tooltip class="item" effect="light" placement="right">
                    <div slot="content">
                      自动填充至"模板内容(中文)"
                    </div>
                    <i class="el-icon-question" style="color: #909399; cursor: pointer;"></i>
                  </el-tooltip>
                </div>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="模版内容（中文）" v-if="internationalVersionFlag == 1">
            <div style="display: flex; align-items: flex-start; gap: 10px;">
              <div id="manualContentTrans" v-html="reqTemplate.contentTrans" contentEditable="plaintext-only" @focus="activeEditableDiv = 'manualContentTrans'" style="width: 35%;height: 150px;border: 1px solid #dcdfe6;border-radius: 4px; overflow-y: auto;">
              </div>
              <el-button v-if="internationalVersionFlag == 1" type="primary" size="small" icon="el-icon-arrow-right" circle @click="translateToFirstLanguage" style="margin-top: 60px;"></el-button>
              <div v-if="internationalVersionFlag == 1" style="position: relative; width: 35%;">
                <div v-html="translatedToFirstLanguage" contentEditable="false" style="width: 100%;height: 150px;border: 1px solid #e4e7ed;border-radius: 4px; overflow-y: auto;background-color: #f5f7fa;cursor: default;">
                </div>
                <div style="position: absolute; right: 5px; bottom: 5px; display: flex; align-items: center; gap: 5px;">
                  <el-button type="text" size="mini" @click="autoFillToOriginal">
                    自动填充
                  </el-button>
                  <el-tooltip class="item" effect="light" placement="right">
                    <div slot="content">
                      自动填充至“模板内容(原文)”
                    </div>
                    <i class="el-icon-question" style="color: #909399; cursor: pointer;"></i>
                  </el-tooltip>
                </div>
              </div>
            </div>
          </el-form-item>
          <el-tabs v-model="addTemplateActiveTab" style="margin-left: 5%;">
            <el-tab-pane label="基本信息" name="baseInfo">
              <el-button
                type="text"
                class="paramter-select"
                v-for="item in templateFiled.baseInfo"
                :key="item.id"
                :title = "internationalVersionFlag == 1 ? (languageSelect === '0' ? item.description : (item.descriptionTrans || item.description)) : null"
                z-index = "999"
                @click="addParamter(item, '')">
                {{internationalVersionFlag == 1 && languageSelect === '0' ? (item.descriptionTrans || item.description) : item.description}}
              </el-button>
              &nbsp;
            </el-tab-pane>
            <el-tab-pane label="金额参数" name="overdueInfo">
              <el-button
                type="text"
                class="paramter-select"
                v-for="item in templateFiled.orgMoneyParam"
                v-if="!(item.flag && calculation.visible)"
                :key="item.id">
                <el-button
                  type="text"
                  class="editParamClass"
                  :title = "internationalVersionFlag == 1 ? (languageSelect === '0' ? item.description : (item.descriptionTrans || item.description)) : null"
                  z-index = "999"
                  @click="addParamter(item, 'money')">
                  {{internationalVersionFlag == 1 && languageSelect === '0' ? (item.descriptionTrans || item.description) : item.description}}
                </el-button>
                &nbsp;
                <el-button
                  type="text"
                  class="el-icon-edit editParamClass"
                  v-if="item.flag"
                  @click="editParamter(item)">
                </el-button>
              </el-button>
              &nbsp;
              <el-row style="margin-top: 10px;">
                <el-button
                  size="mini"
                  @click="calculationAddOrCancle"
                  :class="calculation.buttonSelect.iconClass">
                  {{calculation.buttonSelect.text}}
                </el-button>
              </el-row>
              <el-form
                size="small"
                label-width="40px"
                :hidden = "!calculation.visible"
                style="margin-top: 20px;"
                labelPosition="left">
                <el-row :gutter="24">
                  <el-col :span="10">
                    <el-form-item label="名称">
                      <el-input v-model="calculation.req.description" placeholder="请输入参数名称"/>
                    </el-form-item>
                  </el-col>
                  <el-col :span="14">
                    <el-form-item label="公式">
                      <div id="formula" v-html="calculation.req.customString" rows="2" contentEditable="plaintext-only" style="width: 70%;height: 40px;border: 1px solid #dcdfe6;border-radius: 4px; overflow-y: auto;">
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-button size="mini" type="danger" plain hidden="!calculation.isEdit" @click="deleteCalculation(calculation.req.id)">删除</el-button>
                <el-button size="mini" type="primary" plain @click="addOrUpdateCalculation">保存</el-button>
              </el-form>
            </el-tab-pane>
            <el-tab-pane label="时间参数" name="timeInfo">
              <el-button
                type="text"
                class="paramter-select"
                v-for="item in templateFiled.timeParam"
                :key="item.id"
                :title = "internationalVersionFlag == 1 ? (languageSelect === '0' ? item.description : (item.descriptionTrans || item.description)) : null"
                z-index = "999"
                @click="addParamter(item, '')">
                {{internationalVersionFlag == 1 && languageSelect === '0' ? (item.descriptionTrans || item.description) : item.description}}
              </el-button>
              &nbsp;
            </el-tab-pane>
            <el-tab-pane label="还款信息" name="repaymentInfo">
              <el-button
                type="text"
                class="paramter-select"
                v-for="item in templateFiled.payInfo"
                :key="item.id"
                :title = "internationalVersionFlag == 1 ? (languageSelect === '0' ? item.description : (item.descriptionTrans || item.description)) : null"
                z-index = "999"
                @click="addParamter(item, '')">
                {{internationalVersionFlag == 1 && languageSelect === '0' ? (item.descriptionTrans || item.description) : item.description}}
              </el-button>
              &nbsp;
            </el-tab-pane>
            <el-tab-pane label="公开信息" name="publicInfo">
              <el-button
                type="text"
                class="paramter-select"
                v-for="item in templateFiled.execInfo"
                :key="item.id"
                :title = "internationalVersionFlag == 1 ? (languageSelect === '0' ? item.description : (item.descriptionTrans || item.description)) : null"
                z-index = "999"
                @click="addParamter(item, '')">
                {{internationalVersionFlag == 1 && languageSelect === '0' ? (item.descriptionTrans || item.description) : item.description}}
              </el-button>
              &nbsp;
            </el-tab-pane>
            <el-tab-pane label="拓展信息" name="expandInfo">
              <el-button
                type="text"
                class="paramter-select"
                v-for="item in templateFiled.expandInfo"
                :key="item.id"
                :title = "internationalVersionFlag == 1 ? (languageSelect === '0' ? item.description : (item.descriptionTrans || item.description)) : null"
                z-index = "999"
                @click="addParamter(item, '')">
                {{internationalVersionFlag == 1 && languageSelect === '0' ? (item.descriptionTrans || item.description) : item.description}}
              </el-button>
              &nbsp;
            </el-tab-pane>
            <el-tab-pane label="自定义参数" name="selfDefinedParam">
              <el-button
                type="text"
                class="paramter-select"
                v-for="item in templateFiled.selfDefinedParam"
                :key="item.id"
                :title = "internationalVersionFlag == 1 ? (languageSelect === '0' ? item.description : (item.descriptionTrans || item.description)) : null"
                z-index = "999"
                @click="addParamter(item, '')">
                {{internationalVersionFlag == 1 && languageSelect === '0' ? (item.descriptionTrans || item.description) : item.description}}
              </el-button>
              &nbsp;
            </el-tab-pane>
            <el-tab-pane label="逻辑参数" name="logicParam">
              <el-button
                type="text"
                class="paramter-select"
                v-for="item in templateFiled.logicParam"
                :key="item.id"
                :title = "internationalVersionFlag == 1 ? (languageSelect === '0' ? item.description : (item.descriptionTrans || item.description)) : null"
                z-index = "999"
                @click="addParamter(item, '')">
                {{internationalVersionFlag == 1 && languageSelect === '0' ? (item.descriptionTrans || item.description) : item.description}}
              </el-button>
              &nbsp;
            </el-tab-pane>
            <el-tab-pane label="字典转译参数" name="dzyParam">
              <el-button
                type="text"
                class="paramter-select"
                v-for="item in templateFiled.dzyParam"
                :key="item.id"
                :title = "internationalVersionFlag == 1 ? (languageSelect === '0' ? item.description : (item.descriptionTrans || item.description)) : null"
                z-index = "999"
                @click="addParamter(item, '')">
                {{internationalVersionFlag == 1 && languageSelect === '0' ? (item.descriptionTrans || item.description) : item.description}}
              </el-button>
              &nbsp;
            </el-tab-pane>
          </el-tabs>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="templateVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="addOrUpdateTemplate" size="small" :loading="buttonLoading">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import $ from 'jquery';

export default {
  props: {
    search: {
      type: Function,
      default() {
      }
    }
  },
  data() {
    return {
      mainTemplateOptions: [],
      templateVisible: false,
      typeOptionEdit: '',
      priorityEditable: false,
      isChildTemplate: '',
      promisePayTimeInputVisible: '',
      dialogTitle: '',
      condition: {
        conditionShow: '',
        sex: {
          class: '',
          settingShow: '',
          sexMath: '',
          sexSelect: ''
        },
        executeRecord: {
          class: '',
          settingShow: '',
          executeRecordMath: '',
          executeRecordSelect: ''
        },
        age: {
          class: '',
          settingShow: '',
          ageMath: '',
          ageInput: ''
        },
        keyWord: {
          class: '',
          settingShow: '',
          keyWordMath: '',
          keyWordTextarea: ''
        },
        // ageMathOption
        repayCount: {
          class: '',
          settingShow: '',
          repayCountMath: '',
          repayCountInput: ''
        },
        casePlanDiscount: {
          class: '',
          settingShow: '',
          casePlanDiscountMath: ''
        },
        promisePayTime: {
          class: '',
          settingShow: '',
          promisePayTimeMath: '',
          promisePayTimeInput: ''
        },
        // casePlanDiscountMathOption
        comboxCase: {
          class: '',
          settingShow: '',
          comboxCaseMath: ''
        },
        // ageMathOption
        overdueDate: {
          class: '',
          settingShow: '',
          overdueDatesMath: '',
          overdueDatesInput: ''
        },
        productName: {
          class: '',
          settingShow: '',
          productNameMath: '',
          productNameTextarea: ''
        }
      },
      conditionType: {
        sex: 'sex',
        executeRecord: 'executeRecord',
        age: 'age',
        keyWord: 'keyWord',
        repayCount: 'repayCount',
        casePlanDiscount: 'casePlanDiscount',
        promisePayTime: 'promisePayTime',
        comboxCase: 'comboxCase',
        overdueDate: 'overdueDate',
        productName: 'productName'
      },
      conditionClassType: {
        condition: 'condition',
        conditionSelect: 'condition-select'
      },
      sexMathOption: [
        {
          value: '等于',
          label: '等于'
        },
        {
          value: '不等于',
          label: '不等于'
        }
      ],
      sexSelectOption: [
        {
          value: '男',
          label: '男'
        },
        {
          value: '女',
          label: '女'
        }
      ],
      executeRecordMathOption: [
        {
          value: '等于',
          label: '等于'
        }
      ],
      executeRecordSelectOption: [
        {
          value: '1',
          label: '有记录'
        },
        {
          value: '0',
          label: '无记录'
        }
      ],
      ageMathOption: [
        {
          value: '大于',
          label: '大于'
        },
        {
          value: '等于',
          label: '等于'
        },
        {
          value: '小于',
          label: '小于'
        }
      ],
      keyWordMathOption: [
        {
          value: '包含',
          label: '包含'
        }
      ],
      productNameOption: [
        {
          value: '包含',
          label: '包含'
        }
      ],
      casePlanDiscountMathOption: [
        {
          value: '是',
          label: '是'
        },
        {
          value: '否',
          label: '否'
        }
      ],
      typeOption: [
        {
          value: 'msg',
          label: '短信'
        },
        {
          value: 'ivr',
          label: '语音'
        },
        {
          value: 'ivoice',
          label: '智能语音'
        },
        {
          value: 'svoice',
          label: '场景模板'
        }
      ],
      promisePayTimeMathOption: [
        {
          value: '大于',
          label: '大于'
        },
        {
          value: '等于',
          label: '等于'
        },
        {
          value: '小于',
          label: '小于'
        },
        {
          value: '小于作业停止日',
          label: '小于作业停止日'
        },
        {
          value: '大于作业停止日',
          label: '大于作业停止日'
        }
      ],
      typeValueOption: {
        msg: 'msg',
        voice: 'ivr',
        ivoice: 'ivoice',
        noOption: '',
        sceneTemplate: 'svoice'
      },
      templateFiled: {
        baseInfo: [],
        orgMoneyParam: [],
        timeParam: [],
        payInfo: [],
        execInfo: [],
        expandInfo: [],
        selfDefinedParam: [],
        logicParam: [],
        dzyParam: []
      },
      companyId: '',
      groupId: '',
      reqTemplate: {
        id: '',
        companyId: '',
        groupId: '',
        sort: '',
        parentId: '',
        templateName: '',
        templateContent: '',
        contentTrans: '',
        firstLangContent: '',
        templateStatus: '',
        type: '',
        templateType: '',
        labels: null,
        recorderId: null,
        triggerConditions: [],
        logicType: null
      },
      translatedToChinese: '',
      translatedToFirstLanguage: '',
      addTemplateActiveTab: '',
      templateOperType: {},
      calculation: {
        buttonOption: {
          add: {
            text: '增加计算',
            iconClass: 'el-icon-plus'
          },
          cancle: {
            text: '取消',
            iconClass: 'el-icon-minus'
          },
          cancleEdit: {
            text: '取消编辑',
            iconClass: 'el-icon-minus'
          }
        },
        buttonSelect: '',
        visible: '',
        isEdit: '',
        req: {}
      },
      remoteSearchTimer: null,
      buttonLoading: false,
      labelList: [],
      recorderOption: [],
      templateLogicOption: [],
      triggerConditionOption: [],
      internationalVersionFlag: this.$getInternationalVersionFlag(),
      catchLanguageSelect: this.$getLanguageSelect(),
      catchWorkLanguage: '0',
      workLanguageOptions: [],
      activeEditableDiv: 'manualSendMessageContent', // 默认激活第一语言输入框
      // 分支模板条件
      branchConditionShow: false, // 默认收起
      branchConditions: [], // 条件列表
      branchConditionIndex: 0, // 自增ID
      branchConditionTypeOptions: [], // 条件下拉框（通过接口 /template/getFiledRouteOption 动态获取）
      branchLogicOptions: [] // 逻辑下拉框（通过接口 /conditionDetail/getTemplateConLogicOptionList 动态获取）
    };
  },
  mounted() {
    this.langChangeHandler = (newLang) => {
      this.catchLanguageSelect = newLang;
    };
    this.$bus.$on('languageSelectChanged', this.langChangeHandler);
  },
  beforeDestroy() {
    this.$bus.$off('languageSelectChanged', this.langChangeHandler);
  },
  methods: {
    getTemplateLabels() {
      this.$ajax({
        url: '/scene/getTemplateLabelsByGroupId',
        method: 'GET',
        params: { 'groupId': this.groupId, 'companyId': this.companyId }
      }).then((res) => {
        // eslint-disable-next-line no-console
        console.log(res);
        this.mainTemplateOptions = res.data.map(item => ({
          value: item.id,
          label: item.name
        }));
      });
    },
    getSpecialDictionary(type) {
      this.$ajax({
        url: `/dict/list/${type}`,
        prompt: false,
        method: 'GET'
      }).then((res) => {
        // 处理返回的字典数据
        this.triggerConditionOption = res.data.map(item => ({
          value: item.id,
          label: item.modelName
        }));
      }).catch(() => {
        // 错误处理
      });
    },
    checkNum() {
      this.buttonLoading = true;
      if (this.remoteSearchTimer) {
        clearTimeout(this.remoteSearchTimer);
      }
      this.remoteSearchTimer = setTimeout(() => {
        if ($('#manualSendMessageContent').html()) {
          this.$ajax({
            url: '/template/getContent',
            data: { originalContent: $('#manualSendMessageContent').html() }
          }).then((res) => {
            $('#manualSendMessageContent').html(res.data);
            // 光标移动到最后
            const selectId = 'manualSendMessageContent';
            this.keyAction(selectId);
          });
        }
        this.buttonLoading = false;
      }, 2000);
    },
    getFirstLanguage() {
      const languageSelectOptions = this.workLanguageOptions;
      let firstLanguage = '';
      // 从languageSelectOptions中获取第一语言
      if (languageSelectOptions && languageSelectOptions.length > 0) {
        const nonZeroLang = languageSelectOptions.find(item => item.modelCode === this.catchWorkLanguage);
        if (nonZeroLang) {
          firstLanguage = nonZeroLang.modelName;
        }
      }
      return firstLanguage;
    },
    translateToChinese() {
      const tempDiv = $('<div></div>').html($('#manualSendMessageContent').html());
      const tempFonts = tempDiv.find('.paramFont');
      for (let i = 0; i < tempFonts.length; i++) {
        tempDiv.find('#p'.concat($(tempFonts[i]).attr('id'))).replaceWith($(tempFonts[i]).html());
      }
      let content = tempDiv.html();
      content = content.replace(/<br\s*\/?>$/, '');
      const param = {
        originData: content,
        from: this.getFirstLanguage(),
        to: '中文'
      };
      // 调用翻译接口
      this.$ajax({
        url: '/workflow/translation',
        method: 'POST',
        data: param
      }).then((res) => {
        if (res.data) {
          this.translatedToChinese = res.data;
        }
      }).catch(() => {
        this.$message({
          message: '翻译失败，请稍后重试',
          type: 'error'
        });
      });
    },
    translateToFirstLanguage() {
      const tempDiv = $('<div></div>').html($('#manualContentTrans').html());
      const tempFonts = tempDiv.find('.paramFont');
      for (let i = 0; i < tempFonts.length; i++) {
        tempDiv.find('#p'.concat($(tempFonts[i]).attr('id'))).replaceWith($(tempFonts[i]).html());
      }
      let content = tempDiv.html();
      content = content.replace(/<br\s*\/?>$/, '');
      const param = {
        originData: content,
        from: '中文',
        to: this.getFirstLanguage()
      };
      // 调用翻译接口
      this.$ajax({
        url: '/workflow/translation',
        method: 'POST',
        data: param
      }).then((res) => {
        if (res.data) {
          this.translatedToFirstLanguage = res.data;
        }
      }).catch(() => {
        this.$message({
          message: '翻译失败，请稍后重试',
          type: 'error'
        });
      });
    },
    autoFillToChinese() {
      if (this.translatedToChinese) {
        this.reqTemplate.contentTrans = this.translatedToChinese;
        $('#manualContentTrans').html(this.translatedToChinese);
      }
    },
    autoFillToOriginal() {
      if (this.translatedToFirstLanguage) {
        this.reqTemplate.templateContent = this.translatedToFirstLanguage;
        $('#manualSendMessageContent').html(this.translatedToFirstLanguage);
      }
    },
    initTemplateFiled(templateOperType, companyId) {
      console.warn(companyId);
      this.templateOperType = templateOperType;
      this.$ajax({
        url: '/template/getFiled',
        params: { 'companyId': companyId }
      }).then((res) => {
        this.templateFiled.baseInfo = res.data.基本信息;
        this.templateFiled.orgMoneyParam = res.data.金额参数;
        this.templateFiled.timeParam = res.data.时间参数;
        this.templateFiled.payInfo = res.data.还款信息;
        this.templateFiled.execInfo = res.data.公开信息;
        this.templateFiled.expandInfo = res.data.拓展信息;
        this.templateFiled.selfDefinedParam = res.data.自定义参数;
        this.templateFiled.logicParam = res.data.逻辑参数;
        this.templateFiled.dzyParam = res.data.字典转译参数;
      });
    },
    addOrEditTemplate(templateVisible, templateOper, companyId, groupId, row) {
      this.companyId = companyId;
      this.groupId = groupId;
      this.addTemplateActiveTab = 'baseInfo';
      // 获取标签
      this.labelSearch();
      // 获取录音员
      this.getRecorderList();
      // 获取模版逻辑list
      this.getTemplateLogicList();

      const type = 'triggerCondition';
      this.getSpecialDictionary(type);
      // 获取当前公司语言
      this.getCompanyWorkLanguage(companyId);
      // 获取语言字典
      this.getWorkLanguageOptions();
      // 先获取分支条件下拉框选项（通过接口），加载完成后再执行后续初始化逻辑
      this.getBranchConditionTypeOptions().then(() => {
        switch (templateOper) {
          case this.templateOperType.addMsg: this.addTemplateInitParams(this.typeValueOption.msg, false, false, 0, null); break;
          case this.templateOperType.addVoice: this.addTemplateInitParams(this.typeValueOption.voice, false, false, 0, null); break;
          case this.templateOperType.addIvoice: this.addTemplateInitParams(this.typeValueOption.ivoice, false, false, 0, null); break;
          case this.templateOperType.add: this.addTemplateInitParams(this.typeValueOption.noOption, true, false, 0, null); break;
          case this.templateOperType.addChildTemplate: this.addTemplateInitParams(row.type, false, true, row.newChildTemplateSort, row); break;
          case this.templateOperType.edit: this.editTemplateInitParams(row, row.parentId ? true : null); break;
          case this.templateOperType.addSceneTemplate: this.addTemplateInitParams(this.typeValueOption.sceneTemplate, false, false, 0, null); break;
          default: break;
        }
        this.templateVisible = templateVisible;
      });
    },
    addTemplateInitParams(templateType, typeOptionEdit, isChildTemplate, templateSort, row) {
      const inheritParentSettings = Boolean(row && row.inheritParentSettings);
      let labels = [];
      if (inheritParentSettings && row.labels) {
        labels = Array.isArray(row.labels) ? row.labels.slice() : row.labels.split(',');
      }
      this.getTemplateLabels();
      if (isChildTemplate) this.dialogTitle = '创建分支模板';
      else this.dialogTitle = '创建模板';
      this.calculation.buttonSelect = this.calculation.buttonOption.add;
      this.calculation.visible = false;
      this.reqTemplate = {
        id: '',
        companyId: this.companyId,
        groupId: this.groupId,
        sort: templateSort,
        parentId: row ? row.id : null,
        templateName: row ? row.name : null,
        templateContent: '',
        contentTrans: '',
        firstLangContent: '',
        templateStatus: true,
        type: templateType,
        templateType: '',
        labels,
        recorderId: inheritParentSettings ? row.recorderId : null,
        triggerConditions: row ? row.triggerConditions : [],
        logicType: null
      };
      $('#manualSendMessageContent').html('');
      this.translatedToChinese = '';
      this.translatedToFirstLanguage = '';
      this.typeOptionEdit = typeOptionEdit;
      this.priorityEditable = Boolean(typeOptionEdit || (row && row.priorityEditable));
      this.isChildTemplate = isChildTemplate;
      // 已配置分支模板条件时默认展开
      this.branchConditionShow = row && row.branchConditions && row.branchConditions.length > 0;
      // 从后端回填分支模板条件（异步获取逻辑选项后回填）
      this.initBranchConditionsFromRow(row);
      this.promisePayTimeInputVisible = true;
      this.condition = {
        conditionShow: false,
        sex: {
          class: this.conditionClassType.condition,
          settingShow: false,
          sexMath: this.sexMathOption[0].value,
          sexSelect: this.sexSelectOption[0].value
        },
        executeRecord: {
          class: this.conditionClassType.condition,
          settingShow: false,
          executeRecordMath: this.executeRecordMathOption[0].value,
          executeRecordSelect: this.executeRecordSelectOption[0].value
        },
        age: {
          class: this.conditionClassType.condition,
          settingShow: false,
          ageMath: this.ageMathOption[0].value,
          ageInput: 0
        },
        keyWord: {
          class: this.conditionClassType.condition,
          settingShow: false,
          keyWordMath: this.keyWordMathOption[0].value,
          keyWordTextarea: ''
        },
        // ageMathOption
        repayCount: {
          class: this.conditionClassType.condition,
          settingShow: false,
          repayCountMath: this.ageMathOption[0].value,
          repayCountInput: 0
        },
        casePlanDiscount: {
          class: this.conditionClassType.condition,
          settingShow: false,
          casePlanDiscountMath: this.casePlanDiscountMathOption[0].value
        },
        promisePayTime: {
          class: this.conditionClassType.condition,
          settingShow: false,
          promisePayTimeMath: this.promisePayTimeMathOption[0].value,
          promisePayTimeInput: 0
        },
        // casePlanDiscountMathOption
        comboxCase: {
          class: this.conditionClassType.condition,
          settingShow: false,
          comboxCaseMath: this.casePlanDiscountMathOption[0].value
        },
        // ageMathOption
        overdueDate: {
          class: this.conditionClassType.condition,
          settingShow: false,
          overdueDatesMath: this.ageMathOption[0].value,
          overdueDatesInput: 0
        },
        productName: {
          class: this.conditionClassType.condition,
          settingShow: false,
          productNameMath: this.productNameOption[0].value,
          productNameTextarea: ''
        }
      };
    },
    editTemplateInitParams(row, isChildTemplate) {
      this.getTemplateLabels();
      this.dialogTitle = '编辑模板';
      this.calculation.buttonSelect = this.calculation.buttonOption.add;
      this.calculation.visible = false;
      let labels = [];
      if (row.labels) {
        labels = row.labels.split(',');
      }
      this.reqTemplate = {
        id: row.id,
        companyId: row.companyId,
        groupId: row.groupId,
        sort: row.sort,
        parentId: row.parentId,
        templateName: row.name,
        templateContent: row.content,
        contentTrans: row.contentTrans,
        firstLangContent: '',
        templateStatus: row.status,
        type: row.type,
        templateType: row.templateType,
        labels,
        triggerConditions: row.triggerConditions,
        recorderId: row.recorderId,
        logicType: row.logicType
      };
      $('#manualSendMessageContent').html(this.reqTemplate.templateContent);
      $('#manualContentTrans').html(this.reqTemplate.contentTrans);
      this.translatedToChinese = '';
      this.translatedToFirstLanguage = '';
      this.typeOptionEdit = true;
      this.priorityEditable = true;
      this.isChildTemplate = isChildTemplate;
      // 已配置分支模板条件时默认展开
      this.branchConditionShow = row && row.branchConditions && row.branchConditions.length > 0;
      // 从后端回填分支模板条件（异步获取逻辑选项后回填）
      this.initBranchConditionsFromRow(row);
      this.promisePayTimeInputVisible = true;
      this.condition = {
        conditionShow: false,
        sex: {
          class: this.conditionClassType.condition,
          settingShow: false,
          sexMath: this.sexMathOption[0].value,
          sexSelect: this.sexSelectOption[0].value
        },
        executeRecord: {
          class: this.conditionClassType.condition,
          settingShow: false,
          executeRecordMath: this.executeRecordMathOption[0].value,
          executeRecordSelect: this.executeRecordSelectOption[0].value
        },
        age: {
          class: this.conditionClassType.condition,
          settingShow: false,
          ageMath: this.ageMathOption[0].value,
          ageInput: 0
        },
        keyWord: {
          class: this.conditionClassType.condition,
          settingShow: false,
          keyWordMath: this.keyWordMathOption[0].value,
          keyWordTextarea: ''
        },
        // ageMathOption
        repayCount: {
          class: this.conditionClassType.condition,
          settingShow: false,
          repayCountMath: this.ageMathOption[0].value,
          repayCountInput: 0
        },
        casePlanDiscount: {
          class: this.conditionClassType.condition,
          settingShow: false,
          casePlanDiscountMath: this.casePlanDiscountMathOption[0].value
        },
        promisePayTime: {
          class: this.conditionClassType.condition,
          settingShow: false,
          promisePayTimeMath: this.promisePayTimeMathOption[0].value,
          promisePayTimeInput: 0
        },
        // casePlanDiscountMathOption
        comboxCase: {
          class: this.conditionClassType.condition,
          settingShow: false,
          comboxCaseMath: this.casePlanDiscountMathOption[0].value
        },
        // ageMathOption
        overdueDate: {
          class: this.conditionClassType.condition,
          settingShow: false,
          overdueDatesMath: this.ageMathOption[0].value,
          overdueDatesInput: 0
        },
        productName: {
          class: this.conditionClassType.condition,
          settingShow: false,
          productNameMath: this.productNameOption[0].value,
          productNameTextarea: ''
        }
      };
      // 子案处理
      if (this.isChildTemplate && this.reqTemplate.templateType) this.convertTemplateType(this.reqTemplate.templateType);
    },
    addParamter(item, parameterType) {
      let selectId;
      let html;
      // 根据不同的操作定点不同的文本框,在文本框中加入id不同的html
      if (parameterType === 'money' && this.calculation.visible) {
        // 正在添加或编辑计算公式
        selectId = 'formula';
        html = '<span id="pp'.concat(item.id, '" class="parameter" ondblclick="removeCt2(', item.id, ')" contentEditable="false"  style="color:red">', item.description, '<font id="', item.id, '" class="paramFont2" style="display: none">', item.paramCode, '</font></span>');
      } else {
        // 正在添加模板内容
        selectId = this.activeEditableDiv;
        const description = selectId === 'manualSendMessageContent' ? item.description || item.descriptionTrans : item.descriptionTrans || item.description;
        html = '<span id="p'.concat(item.id, '" class="parameter" ondblclick="removeCt(', item.id, ')" contentEditable="false"  style="color:red">', description, '<font id="', item.id, '" class="paramFont" style="display: none">', item.paramCode, '</font></span>');
      }
      // 把光标放在最文本框的最后面
      const node = window.getSelection().anchorNode;
      if (node) {
        const idName = window.getSelection().getRangeAt(0).startContainer.parentNode.getAttribute('id');
        if (idName !== selectId) {
          this.keyAction(selectId);
        }
      } else this.keyAction(selectId);
      // 插入html
      this.insertHtmlAtCaret(html);
    },
    // 将内容插入到输入光标所在的位置
    insertHtmlAtCaret(html) {
      let sel;
      let range;
      if (window.getSelection) {
        // IE9 and non-IE
        sel = window.getSelection();
        if (sel.getRangeAt && sel.rangeCount) {
          range = sel.getRangeAt(0);
          range.deleteContents();
          // Range.createContextualFragment() would be useful here but is
          // non-standard and not supported in all browsers (IE9, for one)
          const el = document.createElement('div');
          el.innerHTML = html;
          const frag = document.createDocumentFragment();
          const node = el.firstChild;
          const lastNode = frag.appendChild(node);
          range.insertNode(frag);
          // Preserve the selection
          if (lastNode) {
            range = range.cloneRange();
            range.setStartAfter(lastNode);
            range.collapse(true);
            sel.removeAllRanges();
            sel.addRange(range);
          }
        }
      } else if (document.selection && document.selection.type !== 'Control') {
        // IE < 9
        document.selection.createRange().pasteHTML(html);
      }
    },
    // 如果输入光标不在div内，则将光标强行移到div内内容的末端
    keyAction(id) {
      const textbox = document.getElementById(id);
      const sel = window.getSelection();
      const range = document.createRange();
      range.selectNodeContents(textbox);
      range.collapse(false);
      sel.removeAllRanges();
      sel.addRange(range);
    },
    removeCt(id) {
      $('#p'.concat(id)).remove();
    },
    removeCt2(id) {
      $('#pp'.concat(id)).remove();
    },
    editParamter(item) {
      this.calculation.req = {
        id: item.id,
        description: item.description,
        paramCode: item.paramCode,
        customString: item.customString,
        type: item.type,
        flag: item.flag
      };
      this.calculation.isEdit = true;
      this.calculation.buttonSelect = this.calculation.buttonOption.cancleEdit;
      this.calculation.visible = true;
    },
    calculationAddOrCancle() {
      this.calculation.req = {
        id: '',
        description: '',
        paramCode: '',
        customString: '',
        type: '',
        flag: ''
      };
      this.calculation.isEdit = false;
      if (this.calculation.buttonSelect === this.calculation.buttonOption.add) {
        this.calculation.buttonSelect = this.calculation.buttonOption.cancle;
        this.calculation.visible = true;
      } else {
        this.calculation.buttonSelect = this.calculation.buttonOption.add;
        this.calculation.visible = false;
      }
    },
    deleteCalculation(id) {
      this.$confirm('此操作将永久删除该计算公式, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$ajax({
          url: '/template/delParam',
          prompt: true,
          method: 'POST',
          data: { 'id': id }
        }).then(() => {
          this.calculationAddOrCancle();
          this.initTemplateFiled(this.templateOperType, this.companyId);
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    addOrUpdateCalculation() {
      if (!this.calculation.req.description) {
        this.$message({
          message: '请输入参数名称',
          type: 'warning'
        });
        return;
      }
      if (!$('#formula').html()) {
        this.$message({
          message: '请输入参数公式',
          type: 'warning'
        });
        return;
      }
      const fonts = $('.paramFont2');
      for (let i = 0; i < fonts.length; i++) {
        $('#pp'.concat($(fonts[i]).attr('id'))).replaceWith($(fonts[i]).html());
      }
      const re = new RegExp('#LB', 'g'); // 定义正则表达式
      const re2 = new RegExp('BL#', 'g'); // 定义正则表达式
      // 第一个参数是要替换掉的内容，第二个参数"g"表示替换全部（global）
      // 第一个参数是正则表达式
      const Newstr = $('#formula').html().replace(re, '').replace(re2, '')
        .trim();
      this.calculation.req.paramCode = '#FM'.concat(Newstr, 'MF#');
      this.calculation.req.type = '金额参数';
      this.calculation.req.flag = true;
      const req = {
        'id': this.calculation.req.id,
        'description': this.calculation.req.description,
        'paramCode': this.calculation.req.paramCode,
        'type': this.calculation.req.type,
        'flag': this.calculation.req.flag,
        'companyId': this.companyId
      };
      this.$ajax({
        url: '/template/updateOrInsertFiled',
        prompt: true,
        method: 'POST',
        data: req
      }).then(() => {
        this.calculationAddOrCancle();
        this.initTemplateFiled(this.templateOperType, this.companyId);
      });
    },
    addOrUpdateTemplate() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      if (!this.reqTemplate.type) {
        loading.close();
        this.$message({
          message: '请输入模板类型',
          type: 'warning'
        });
        return;
      }
      if (!this.reqTemplate.templateName) {
        loading.close();
        this.$message({
          message: '请输入模板名称',
          type: 'warning'
        });
        return;
      }
      if (this.reqTemplate.templateName.length > 16) {
        loading.close();
        this.$message({
          message: '模版名称汉字或字符不能超过16个，请重新输入',
          type: 'warning'
        });
        return;
      }
      if (!$('#manualSendMessageContent').html()) {
        loading.close();
        this.$message({
          message: '请输入模板内容',
          type: 'warning'
        });
        return;
      }
      // 在克隆的DOM上提取原始参数码，避免污染编辑器实际DOM
      const contentClone = $('#manualSendMessageContent').clone();
      // 优先通过.paramFont隐藏字体提取原始码（保持与原有逻辑一致）
      const cloneFonts = contentClone.find('.paramFont');
      for (let i = 0; i < cloneFonts.length; i++) {
        contentClone.find('#p'.concat($(cloneFonts[i]).attr('id'))).replaceWith($(cloneFonts[i]).html());
      }
      // 兜底：如果无.paramFont，去除span/font标签提取纯文本内容（保留br等基础标签）
      if (cloneFonts.length === 0) {
        let cloneHtml = contentClone.html();
        // 去除所有span/font标签（保留内部文本如#LBloanInstitutionsBL#和br标签）
        cloneHtml = cloneHtml.replace(/<\/?span[^>]*>/g, '');
        cloneHtml = cloneHtml.replace(/<\/?font[^>]*>/g, '');
        contentClone.html(cloneHtml);
      }

      // 同样处理模板内容（中文），提取参数码
      let contentTransResult = '';
      const $manualContentTrans = $('#manualContentTrans');
      if ($manualContentTrans.length > 0) {
        const contentTransClone = $manualContentTrans.clone();
        const transCloneFonts = contentTransClone.find('.paramFont');
        for (let i = 0; i < transCloneFonts.length; i++) {
          contentTransClone.find('#p'.concat($(transCloneFonts[i]).attr('id'))).replaceWith($(transCloneFonts[i]).html());
        }
        if (transCloneFonts.length === 0) {
          let transCloneHtml = contentTransClone.html();
          if (transCloneHtml) {
            transCloneHtml = transCloneHtml.replace(/<\/?span[^>]*>/g, '');
            transCloneHtml = transCloneHtml.replace(/<\/?font[^>]*>/g, '');
            contentTransClone.html(transCloneHtml);
          }
        }
        contentTransResult = contentTransClone.html() || '';
      }
      if (this.reqTemplate.parentId) {
        // 子案
        let templateType = '';
        if (this.condition.sex.settingShow) templateType = templateType.concat('性别 ', this.condition.sex.sexMath, ' ', this.condition.sex.sexSelect, ';');
        // age
        if (!this.condition.age.ageInput) this.condition.age.ageInput = 0;
        if (this.condition.age.settingShow) templateType = templateType.concat('年龄 ', this.condition.age.ageMath, ' ', this.condition.age.ageInput, ';');
        // repayCount
        if (!this.condition.repayCount.repayCountInput) this.condition.repayCount.repayCountInput = 0;
        if (this.condition.repayCount.settingShow) templateType = templateType.concat('逾期次数 ', this.condition.repayCount.repayCountMath, ' ', this.condition.repayCount.repayCountInput, ';');
        // promisePayTime
        if (!this.condition.promisePayTime.promisePayTimeInput) this.condition.promisePayTime.promisePayTimeInput = 0;
        if (this.condition.promisePayTime.settingShow) {
          if (this.condition.promisePayTime.promisePayTimeMath === '大于作业停止日' || this.condition.promisePayTime.promisePayTimeMath === '小于作业停止日') {
            templateType = templateType.concat('承诺还款时间距离当前天数 ', this.condition.promisePayTime.promisePayTimeMath, ';');
          } else templateType = templateType.concat('承诺还款时间距离当前天数 ', this.condition.promisePayTime.promisePayTimeMath, ' ', this.condition.promisePayTime.promisePayTimeInput, ';');
        }
        // comboxCase
        if (this.condition.comboxCase.settingShow) templateType = templateType.concat('是否合并案件 ', this.condition.comboxCase.comboxCaseMath, ';');
        // overdueDate
        if (!this.condition.overdueDate.overdueDatesInput) this.condition.overdueDate.overdueDatesInput = 0;
        if (this.condition.overdueDate.settingShow) templateType = templateType.concat('逾期天数 ', this.condition.overdueDate.overdueDatesMath, ' ', this.condition.overdueDate.overdueDatesInput, ';');
        // executeRecord
        if (this.condition.executeRecord.settingShow) templateType = templateType.concat('法院执行记录 ', this.condition.executeRecord.executeRecordMath, ' ', this.condition.executeRecord.executeRecordSelect, ';');
        // keyWord
        if (this.condition.keyWord.settingShow && this.condition.keyWord.keyWordTextarea) templateType = templateType.concat('关键词 ', this.condition.keyWord.keyWordMath, ' ', this.condition.keyWord.keyWordTextarea, ';');
        // productName
        if (this.condition.productName.settingShow && this.condition.productName.productNameTextarea) templateType = templateType.concat('产品名称 ', this.condition.productName.productNameMath, ' ', this.condition.productName.productNameTextarea, ';');
        // casePlanDiscount
        if (this.condition.casePlanDiscount.settingShow) templateType = templateType.concat('是否减免 ', this.condition.casePlanDiscount.casePlanDiscountMath, ';');
        if (templateType) this.reqTemplate.templateType = templateType;
      }
      // 构建分支模板条件请求参数
      const branchConditionsReq = this.buildBranchConditionsReq();
      const req = {
        'id': this.reqTemplate.id,
        'companyId': this.companyId,
        'groupId': this.groupId,
        'sort': this.reqTemplate.sort,
        'parentId': this.reqTemplate.parentId,
        'name': this.reqTemplate.templateName,
        'content': contentClone.html(),
        'contentTrans': contentTransResult,
        'firstLangContent': this.reqTemplate.firstLangContent,
        'status': this.reqTemplate.templateStatus,
        'type': this.reqTemplate.type,
        'templateType': this.reqTemplate.templateType,
        'labels': this.reqTemplate.labels,
        'recorderId': this.reqTemplate.recorderId,
        'triggerConditions': this.reqTemplate.triggerConditions,
        'logicType': this.reqTemplate.logicType,
        'branchConditions': branchConditionsReq
      };
      if (this.reqTemplate.type === 'svoice') {
        this.$ajax({
          url: '/scene/updateOrInsertTemplate',
          prompt: true,
          method: 'POST',
          data: req
        }).then(() => {
          loading.close();
          this.templateVisible = false;
          this.calculationAddOrCancle();
          this.initTemplateFiled(this.templateOperType, this.companyId);
          this.search();
          window.eventBus.$emit('templateHadChange', null);
        }).catch(() => {
          loading.close();
        });
      } else {
        this.$ajax({
          url: '/template/updateOrInsertTemplate',
          prompt: true,
          method: 'POST',
          data: req
        }).then(() => {
          loading.close();
          this.templateVisible = false;
          this.calculationAddOrCancle();
          this.initTemplateFiled(this.templateOperType, this.companyId);
          this.search();
          window.eventBus.$emit('templateHadChange', null);
        }).catch(() => {
          loading.close();
        });
      }
    },
    deleteTemplate(id) {
      this.$confirm('确定删除该模板?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$ajax({
          url: '/template/deleteTemplate',
          prompt: true,
          method: 'POST',
          data: {
            'id': id,
            'status': true
          }
        }).then(() => {
          this.search();
          window.eventBus.$emit('templateHadChange', null);
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    openAndCloseTemplate(row) {
      this.$ajax({
        url: '/template/updateTemplateStatus',
        prompt: true,
        method: 'POST',
        data: {
          'id': row.id,
          'status': row.status
        }
      }).catch(() => {
        row.status = !row.status;
      });
    },
    openAndCloseSceneTemplate(row) {
      this.$ajax({
        url: '/scene/updateTemplateStatus',
        prompt: true,
        method: 'POST',
        data: {
          'id': row.id,
          'status': row.status
        }
      }).catch(() => {
        row.status = !row.status;
      });
    },
    deploy(show) {
      this.condition.conditionShow = show;
    },
    conditionClick(conditionType, settingShow) {
      const condition = this.condition[conditionType];
      condition.settingShow = !settingShow;
      if (condition.settingShow) condition.class = this.conditionClassType.conditionSelect;
      else condition.class = this.conditionClassType.condition;
    },
    promisePayTimeMathChange(val) {
      if (val === '大于作业停止日' || val === '小于作业停止日') {
        this.promisePayTimeInputVisible = false;
      } else this.promisePayTimeInputVisible = true;
    },
    convertTemplateType(templateType) {
      const split = templateType.split(';');
      split.forEach((e) => {
        const temp = e.split(' ');
        if (temp[0] === '性别') {
          this.conditionClick(this.conditionType.sex, false);
          this.condition.sex.sexMath = temp[1];
          this.condition.sex.sexSelect = temp[2];
        } else if (temp[0] === '年龄') {
          this.conditionClick(this.conditionType.age, false);
          this.condition.age.ageMath = temp[1];
          this.condition.age.ageInput = temp[2];
        } else if (temp[0] === '逾期次数') {
          this.conditionClick(this.conditionType.repayCount, false);
          this.condition.repayCount.repayCountMath = temp[1];
          this.condition.repayCount.repayCountInput = temp[2];
        } else if (temp[0] === '承诺还款时间距离当前天数') {
          this.conditionClick(this.conditionType.promisePayTime, false);
          this.condition.promisePayTime.promisePayTimeMath = temp[1];
          this.condition.promisePayTime.promisePayTimeInput = temp[2];
        } else if (temp[0] === '逾期天数') {
          this.conditionClick(this.conditionType.overdueDate, false);
          this.condition.overdueDate.overdueDatesMath = temp[1];
          this.condition.overdueDate.overdueDatesInput = temp[2];
        } else if (temp[0] === '法院执行记录') {
          this.conditionClick(this.conditionType.executeRecord, false);
          this.condition.executeRecord.executeRecordMath = temp[1];
          this.condition.executeRecord.executeRecordSelect = temp[2];
        } else if (temp[0] === '关键词') {
          this.conditionClick(this.conditionType.keyWord, false);
          this.condition.keyWord.keyWordMath = temp[1];
          this.condition.keyWord.keyWordTextarea = temp[2];
        } else if (temp[0] === '是否减免') {
          this.conditionClick(this.conditionType.casePlanDiscount, false);
          this.condition.casePlanDiscount.casePlanDiscountMath = temp[1];
        } else if (temp[0] === '是否合并案件') {
          this.conditionClick(this.conditionType.comboxCase, false);
          this.condition.comboxCase.comboxCaseMath = temp[1];
        } else if (temp[0] === '产品名称') {
          this.conditionClick(this.conditionType.productName, false);
          this.condition.productName.productNameMath = temp[1];
          this.condition.productName.productNameTextarea = temp[2];
        }
      });
    },
    labelSearch() {
      if (this.companyId == null || this.companyId === undefined || this.companyId === '') {
        return;
      }
      if (this.groupId == null || this.groupId === undefined || this.groupId === '') {
        return;
      }
      this.$ajax({
        method: 'POST',
        url: '/label/getLabelParams',
        data: {
          companyId: this.companyId,
          groupId: this.groupId
        }
      }).then((res) => {
        this.labelList = res.data;
      });
    },
    // 获取录音员
    getRecorderList() {
      this.$ajax({
        method: 'POST',
        url: '/recorder/list',
        data: {
          status: 1
        }
      }).then((res) => {
        this.recorderOption = res.data;
      });
    },
    // 获取scene模版logic list
    getTemplateLogicList() {
      this.$ajax({
        method: 'POST',
        url: '/scene/getTemplateLogicList'
      }).then((res) => {
        this.templateLogicOption = res.data;
      });
    },
    getCompanyWorkLanguage(companyId) {
      this.$ajax({
        url: '/company/getCompanyByPrimaryKey',
        params: { companyId },
        method: 'GET'
      }).then((res) => {
        this.catchWorkLanguage = res.data.workLanguage;
        this.internationalVersionFlag = res.data.internationalVersionFlag;
      }).catch((error) => {
        this.$message({
          type: 'error',
          message: error.message
        });
      });
    },
    getWorkLanguageOptions() {
      this.$ajax({
        url: '/dict/list/workLanguage',
        method: 'GET'
      }).then((res) => {
        this.workLanguageOptions = res.data;
      });
    },
    getBranchConditionTypeOptions() {
      return this.$ajax({
        url: '/template/getFiledRouteOption',
        params: { 'companyId': this.companyId }
      }).then((res) => {
        // 将接口返回数据映射为组件内统一使用的格式：{ value, label, id }
        // 接口返回 { id, description }，其中 id 同时作为 value 和 id
        const options = (res.data || []).map(item => ({
          value: item.id,
          label: item.description,
          id: item.id
        }));
        // 逾期天数、逾期金额、入案天数置顶
        const topLabels = ['逾期天数', '逾期金额', '入案天数（0~30）'];
        const topOptions = [];
        const otherOptions = [];
        options.forEach((opt) => {
          if (topLabels.includes(opt.label)) {
            topOptions.push(opt);
          } else {
            otherOptions.push(opt);
          }
        });
        this.branchConditionTypeOptions = [...topOptions, ...otherOptions];
      });
    },
    // 从后端数据回填分支模板条件（异步获取逻辑选项）
    initBranchConditionsFromRow(row) {
      if (!row || !row.branchConditions || !Array.isArray(row.branchConditions)) {
        this.branchConditions = [];
        this.branchConditionIndex = 0;
        return;
      }

      this.branchConditionIndex = 0;
      // 先创建条件列表，conditionType 用接口选项映射
      const conditions = row.branchConditions.map((bc) => {
        const conditionOption = this.branchConditionTypeOptions.find(item => item.id === bc.conditionId);
        return {
          id: this.branchConditionIndex++,
          conditionType: conditionOption ? conditionOption.value : '',
          logicType: '', // 逻辑选项异步加载后回填
          minValue: bc.param1 || '',
          maxValue: bc.param2 || '',
          logicOptions: [],
          storedLogicId: bc.logicId // 临时字段，用于逻辑选项加载后匹配
        };
      });
      this.branchConditions = conditions;

      // 收集所有需要获取逻辑选项的唯一条件类型
      const uniqueConditionTypes = [...new Set(
        conditions.filter(c => c.conditionType).map(c => c.conditionType)
      )];

      if (uniqueConditionTypes.length === 0) return;

      // 并行获取各条件类型的逻辑选项
      const logicFetchPromises = uniqueConditionTypes.map(ct => this.$ajax({
        url: '/conditionDetail/getTemplateConLogicOptionList',
        method: 'POST',
        data: ct
      }).then((res) => {
        const logicOptions = (res.data || []).map(item => ({
          value: String(item.code),
          label: item.desc,
          id: item.code,
          isRange: ['11', '12', '13', '14'].includes(String(item.code)) // 与条件路由-编辑一致的区间判断
        }));
        return { conditionType: ct, logicOptions };
      }));

      Promise.all(logicFetchPromises).then((results) => {
        // 构建 conditionType → logicOptions 映射
        const logicOptionsMap = {};
        results.forEach((r) => { logicOptionsMap[r.conditionType] = r.logicOptions; });

        // 回填每个条件的逻辑选项和 logicType
        this.branchConditions.forEach((c) => {
          if (c.conditionType && logicOptionsMap[c.conditionType]) {
            c.logicOptions = logicOptionsMap[c.conditionType];
            if (c.storedLogicId != null) {
              const logicOption = c.logicOptions.find(item => item.id === c.storedLogicId);
              c.logicType = logicOption ? logicOption.value : '';
            }
          }
          delete c.storedLogicId;
        });
      });
    },
    // 根据 conditionType 值获取对应的 label（用于判断是否显示入案时间提示）
    getSelectedConditionLabel(conditionType) {
      if (!conditionType) return '';
      const option = this.branchConditionTypeOptions.find(item => item.value === conditionType);
      return option ? option.label : '';
    },
    // 条件下拉框变更时，重置逻辑并获取对应条件的逻辑下拉选项
    onBranchConditionChange(index) {
      const condition = this.branchConditions[index];
      // 重置逻辑选择
      condition.logicType = '';
      condition.logicOptions = [];
      condition.minValue = '';
      condition.maxValue = '';
      // 如果选择了条件，获取对应的逻辑选项
      if (condition.conditionType) {
        this.getBranchLogicOptions(condition.conditionType, index);
      }
    },
    // 获取逻辑下拉选项
    getBranchLogicOptions(conditionType, index) {
      this.$ajax({
        url: '/conditionDetail/getTemplateConLogicOptionList',
        method: 'POST',
        data: conditionType
      }).then((res) => {
        // 将接口返回 { code, desc } 映射为 { value, label, id, isRange }
        const logicOptions = (res.data || []).map(item => ({
          value: String(item.code),
          label: item.desc,
          id: item.code,
          isRange: ['11', '12', '13', '14'].includes(String(item.code)) // 区间类型判断（与条件路由-编辑一致）
        }));
        this.branchConditions[index].logicOptions = logicOptions;
      });
    },
    // 判断逻辑码是否属于区间类型（需要两个参数输入框）
    isBranchRangeLogic(logicCode) {
      if (!logicCode && logicCode !== 0) return false;
      return ['11', '12', '13', '14'].includes(String(logicCode));
    },
    addBranchCondition() {
      this.branchConditions.push({
        id: this.branchConditionIndex++,
        conditionType: '',
        logicType: '',
        minValue: '',
        maxValue: '',
        logicOptions: [] // 每个条件独立的逻辑下拉选项
      });
    },
    removeBranchCondition(index) {
      this.branchConditions.splice(index, 1);
    },
    buildBranchConditionsReq() {
      const conditions = [];
      this.branchConditions.forEach((condition) => {
        if (!condition.conditionType) return;
        const conditionOption = this.branchConditionTypeOptions.find(item => item.value === condition.conditionType);
        const logicOption = (condition.logicOptions || []).find(item => item.value === condition.logicType);
        const conditionReq = {
          conditionId: conditionOption ? conditionOption.id : null,
          conditionDesc: conditionOption ? conditionOption.label : '',
          logicId: logicOption ? logicOption.id : null,
          logicDesc: logicOption ? logicOption.label : '',
          param1: condition.minValue || '',
          param2: this.isBranchRangeLogic(condition.logicType) ? (condition.maxValue || '') : ''
        };
        conditions.push(conditionReq);
      });
      return conditions;
    }
  },
  computed: {
    languageSelect() {
      return this.catchLanguageSelect;
    }
  }
};
</script>
<style lang="less" scoped>
.paramter-select {
  margin-top: 10px;
  margin-left: 0px;
  padding: 0.5em 3em 0.5em 0em;
}
.parameter {
  cursor: url("/static/imgs/cur.png"), auto;
}
.editParamClass {
  border: none;
  margin: 0px 0px;
  padding: 0em 0em;
}
.condition {
  width: 12em;
  background-color: transparent;
  border: none;
  padding: 10px 0px;
}
.condition-select {
  width: 12em;
  background-color: #F6AC19;
  border: none;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/page/main/collection/engine/add_template.vue